
import axios ,{ AxiosRequestConfig, AxiosResponse } from 'axios';
import { getToken,removeToken,getRefreshToken,removeRefreshToken,setRefreshToken,setToken} from '@/utils/auth'
import { login, logout, getUserInfo,loginToken } from '@/api/login'
import {message} from 'ant-design-vue';
import Cookies from 'js-cookie';
import config2 from "@/config.js";
import { MagicString } from 'vue/compiler-sfc';
 import { useRouter } from 'vue-router';
  const router = useRouter();
// axios.defaults.retry = 4;
// axios.defaults.retryDelay = 1000;
let refreshing = false// 正在刷新标识，避免重复刷新
let refreshSubscribers = []
type selfRes = {
  code?: number | string,
  msg?: string,
  data?: any
}
// 创建axios实例
const request = axios.create({
    baseURL:import.meta.env.VITE_BASE_URL + 'api',// 所有的请求地址前缀部分
    timeout: 1800000, // 请求超时时间(毫秒)
    withCredentials: true,// 异步请求携带cookie
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
    },
})
 
// interface CustomAxiosConfig extends AxiosRequestConfig {
//   proUrl?: string;
// }

// location.href = `${(config as CustomAxiosConfig).proUrl}/#/login`;
// request拦截器
request.interceptors.request.use(
    config => {
        const isToken = (config.headers || {}).isToken === false
        // 是否需要防止数据重复提交
        const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
        //if (getToken() && !isToken) {
        config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
        //config.headers['Authorization'] = `Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJtb2JpbGVQaG9uZSI6IjE1MjU1NDc3OTE5IiwiYXV0aGVudGljYXRpb25NZXRob2QiOiJ1c2VybmFtZSIsInVzZXJfbmFtZSI6InFpYW54aWFvZG9uZyIsImlkQ2FyZCI6IjM0MjYyMjE5OTUwMTE3MDYzMyIsInNjb3BlIjpbImFsbCJdLCJleHAiOjE3NjA5MjE2MjIsInVzZXJJZCI6ImFkZjAxNGU5OGVlNTQ4MGI4YmNhN2I1MjQ5N2RjODIyIiwiYXV0aG9yaXRpZXMiOlsiUE1TX0RFUFRfQURNSU4iLCJTVFJBVEVHWV9MSVNUIiwiU0FMQVJZX1JPTEUiLCJTQUxfU1RBUlRfUk9MRSIsIkhSX1JPTEUiLCJFUVVJUE1FTlRfQURNSU5fVVNFUiIsInByb2RCaWRQdXJjaGFzZUFkbWluIiwiSFJfV0VJSFVfUk9MRSIsIkVYUEVOU0VTX1JPTEUiLCJURUNITklDQUxfREVQVF9ST0xFIiwiVVNFUl9JTlRFTlRJT05fQURNSU4iLCJ0ZW5kZXJQcm9qZWN0SW5kZXhUcmFuc2ZlciIsIkNPTlRSQUNUX0FETUlOIiwiT1BUX0NPTlRSQUNUX1JPTEUiLCJCVVNJTkVTU19JTkNFTlRJVkUiLCJQQVJBTV9BRE1JTiIsImN1c3RNYWpvckFkbWluUm9sZSIsIkJpel9MZWRnZXJfUm9sZSIsIllKX0VESVRTX1JPTEUiLCJNQVJLRVRfTUFOQUdFTUVOVF9ST0xFIiwiUVVFU1RJT05OQUlSRSIsIldPUktfTE9HX01BTkFHRSIsIlNVUEVSX0FETUlOIiwiUE1TX1dUX0RKWSIsIkRaUkxZIiwiTUFSS0VUX0NSTV9BRE1JTiIsIkJJRF9GSUxFX1JPTEUiLCJKQ0pUX0FETUlOIiwiRmluYW5jZUJvYXJkUm9sZSIsIkpDSlRfQ09NTU9OIiwiSllfREFUQUVOVFJZX0FETUlOIiwiQ0FSRUVSX0FETUlOX1VTRVIiLCJsZWFkZXJLYkdyb3VwQnVzaUp0IiwiUE1TX0FETUlOIiwiUE1TX1dUX0FETUlOX0RKWSIsIkJpel9MZWRnZXJfUm9sZV9hZG1pbiIsIllXR0xZIiwiVEVDSE5JQ0FMX1JPTEUiLCJCSURfU1RBTkRfQURNSU4iLCJBc3Nlc3NBZG1pbiIsIlRKX1FaSl9BRE1JTiIsInByb2RCaWRQdXJjaGFzZUFsbCIsIlBMQU5fQURNSU4iLCJMRUFERVJWSUVXX0FETUlOIiwiTEFXX1JVTEVfUk9MRSJdLCJqdGkiOiIwMGRjNmQ3OS1lNmQ4LTRjM2EtOGJkZi05NGQ2ZDY4ODc2MDEiLCJjbGllbnRfaWQiOiJhaGpnamMtYWRtaW4td2ViIiwidXNlcm5hbWUiOiJxaWFueGlhb2RvbmcifQ.YwnF4dKjYMZ6LzjmqTSIAXCy2yMxWRvp3SI2RLk9-sy8nfa44KgxETSy-enwO6co8yPxT3n7VsH75Kr6NLN2t3Weu64actvYb7_WoyVRzNF2uLGeNcooQuZ67VgCnWtPSvrWS8V5bHERBjIiEIHfN6vDJkrSBZ7J4WIqetw_2v6lVKLCCWzKtFiHZfsjLfKknsrAk4ULnbikkPjw_KmxGP_HDdWNScaUSNoQv2uvifuPhlWZ-aIZmydFLhpfsiJq_RFRgzJAj-UN_qiff3hZTiMVPIRvXS1C2l4rxcsx7G-WlaWeVXPSaNjhyQqIc2s6JAYSiQ0zR0OWcv_bu7noyw`
       // }
        
        // get请求映射params参数
        // if (config.method === 'get' && config.params) {
        //     let url = config.url + '?' + tansParams(config.params);
        //     url = url.slice(0, -1);
        //     config.params = {};
        //     config.url = url;
        // }
        if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
            const requestObj = {
            url: config.url,
            data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
            time: new Date().getTime()
            }
        
        }
        
        if(config.url){
            let lowerUrl = config.url.toLowerCase()
            if (lowerUrl.includes('export') || lowerUrl.includes('download') || lowerUrl.includes('createQr')) {
                config['responseType'] = 'blob'
            }
        }
        return config
    },
    error => {
        // 对请求错误做些什么
        Promise.reject(error)
    }
)

// 全局状态变量
let hasTokenExpired = false; // token是否已过期
// response 拦截器
request.interceptors.response.use(

  (response:AxiosResponse<selfRes>) => {
       console.log(response,'response8888')
       const {code, msg, data} = response.data
        // 对响应数据做点什么
        // return response.data
            if (code === 'A0230') {
                const config = response.config
                message.warning('过期请重新扫码登录！')
                removeToken();
                location.href = `${config2.proUrl}/#/login`;
                // if(refreshing == false){
                //     refreshing = true
                //     let formData = new FormData();
                //     let refresh_token = getRefreshToken();
                //     formData.append('refresh_token',refresh_token)
                //     formData.append('grant_type',"refresh_token")
                //     removeToken();
                //     removeRefreshToken();
                //      return loginToken(formData).then((token) => {
                //         setRefreshToken(res.data.refresh_token);
                //         setToken(res.data.access_token);
                  
                //         refreshSubscribers.forEach(callback => callback(token)) // 已刷新token，所有队列中的请求重试
                //         refreshSubscribers = []
                //         return request(config)
                //     }).catch(() => { // refresh_token也过期，直接跳转登录页面重新登录
                //         message.warning(msg || '系统出错')
                
                //     }).finally(() => {
                //         refreshing = false
                //     })
                // }else {
                //     // 正在刷新token，返回未执行resolve的Promise,刷新token执行回调
                //     return new Promise((resolve => {
                //     refreshSubscribers.push(() => {
                //         config.baseURL = '' // 请求重试时，url已包含baseURL
                //         resolve(request(config))
                //     })
                //     }))
                // }
            }
             if(response.config['responseType'] === 'blob'){
                return response
            }else{
                return response.data
            }
        
    },
    error => {  
        console.log(error.response,'error********')
        // 对响应错误做点什么
        const { status } = error.response
        let code='',msg='',config=''
        if(error.response){
            code =  error.response?error.response.data.code:''
            msg = error.response.data.msg
            config = error.response.config;
        }
        console.log(code,'code---------------')
        // 如果token已经过期，直接拒绝后续请求
        if (hasTokenExpired) {
            // message.warning('登录已过期，请重新登录');
            removeToken();
            setTimeout(() => {
                location.href = `${config2.proUrl}/#/login`;
            }, 100);
            return Promise.reject(new Error('Token已过期，请求被中止'));
        }
        // 流获取失败
        if(!code&&status=='500'){
            return Promise.reject(error)
        }
        if(code === 'B0001'){
            message.warning(msg || '登录超时')
        location.href = '/#/login';
        }else if(code === 'A0210'){
            message.warning(msg || '登录名或密码不正确')
        }else if(code=='A0230'){    
            // 第一次检测到token过期
            if (!hasTokenExpired) {
                hasTokenExpired = true;
                message.warning('登录已过期，请重新登录');
                removeToken();
                setTimeout(() => {
                    location.href = `${config2.proUrl}/#/login`;
                }, 100);
            }
            // message.warning('过期请重新扫码登录！')
            // removeToken();
            // location.href = `${config2.proUrl}/#/login`;





            // if (refreshing == false) {
            //     refreshing = true
            //     let formData = new FormData();
            //     let refresh_token = getRefreshToken();
            //     formData.append('refresh_token',refresh_token)
            //     formData.append('grant_type',"refresh_token")
            //     removeToken();
            //     removeRefreshToken();
            //     return loginToken(formData).then(res => {
            //               console.log(res,'resres error')
            //               if(res){
            //                 setRefreshToken(res.data.refresh_token);
            //                 setToken(res.data.access_token);
                   
            //                 refreshSubscribers.forEach(callback => callback()) // 已刷新token，所有队列中的请求重试
                        
            //                 refreshSubscribers = [];
            //               }else{
            //                 location.href = '/';
            //               }
                          
            //               return request(config)
            //             }).finally(() => {
            //               refreshing = false;
                          
            //             })
            // }
        }else{
            message.error('系统出错')
        //   store.commit("app/CHANGE_DOWNLOADING",false);
        }

        // return Promise.reject(error)
    }
)


export default request